import { render, staticRenderFns } from "./ChromatogramEdit.vue?vue&type=template&id=8edc649c&scoped=true&"
import script from "./ChromatogramEdit.vue?vue&type=script&lang=js&"
export * from "./ChromatogramEdit.vue?vue&type=script&lang=js&"
import style0 from "./ChromatogramEdit.vue?vue&type=style&index=0&id=8edc649c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8edc649c",
  null
  
)

export default component.exports